import React, { useState, memo, useEffect } from 'react';
import { connect } from 'react-redux';
import Modal from 'components/shared/Modal/Modal';
import ActionDevicesTable from 'components/features/ActionDevicesTable/ActionDevicesTable';
import CreateDevicesListForm from 'components/features/CreateDevicesListModal/CreateDevicesListForm';
import './CreateDevicesListModal.css';
import { DEVICES_PAGE_TAB } from 'common/utils/constants';

const BulkCreateDevicesListModal = (props) => {
  const { selectedDevicesDictionary, afterModalClose, handleSave } = props;
  const [localSelectedDevicesDictionary, setLocalSelectedDevicesDictionary] = useState(null);

  useEffect(() => {
    if (selectedDevicesDictionary && !localSelectedDevicesDictionary && Object.keys(selectedDevicesDictionary).length) {
      let newLocalSelectedDevicesDictionary = {};
      Object.keys(selectedDevicesDictionary).forEach((deviceId) => {
        newLocalSelectedDevicesDictionary[deviceId] = { checked: true, matched: true };
      });
      setLocalSelectedDevicesDictionary(newLocalSelectedDevicesDictionary);
    }
  }, [localSelectedDevicesDictionary, selectedDevicesDictionary]);

  return (
    <Modal close={afterModalClose} global noPadding height={645} width={862}>
      <div className="BulkCreateDevicesListModal">
        <ActionDevicesTable
          localSelectedDevicesDictionary={localSelectedDevicesDictionary}
          setLocalSelectedDevicesDictionary={setLocalSelectedDevicesDictionary}
          selectedDevicesData={props.selectedDevicesData}
          // deviceIdList={deviceIdList}
        />
        <CreateDevicesListForm
          activeTab={props.activeTab}
          localSelectedDevicesDictionary={localSelectedDevicesDictionary}
          selectedDevicesData={props.selectedDevicesData}
          handleSave={handleSave}
        />
      </div>
    </Modal>
  );
};

export default connect((store) => {
  const activeTab = store.ui.devicesPage.activeTab;
  let selectedDevicesData;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    selectedDevicesData = store.data.selectedDevicesDataPivotTab;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    selectedDevicesData = store.data.selectedDevicesDataEchoTab;
  } else {
    selectedDevicesData = store.data.selectedDevicesDataAllDevicesTab;
  }

  return {
    activeTab,
    selectedDevicesData
  }
})(memo(BulkCreateDevicesListModal));
